import { SponsorCard } from '../../cards';
import { ContentList } from '../../ContentList';

import { selectSiteDiscoverySponsorRecord } from '../../../../../../store/features/discovery';
import { useRootSelector } from '../../../../../../store/hooks';
import { UseInfiniteScrollProps } from '../../../../../../hooks';

export interface SponsorListProps {
  loadMoreResults: UseInfiniteScrollProps['fetchMoreData'];
  enableLoadingByScroll: boolean;
}

export function SponsorList(props: SponsorListProps) {
  const { loadMoreResults, enableLoadingByScroll } = props;
  const { results, totalPages } = useRootSelector((state) =>
    selectSiteDiscoverySponsorRecord(state),
  );

  return (
    <ContentList
      items={results}
      totalPage={totalPages}
      onLoadMore={loadMoreResults}
      enableLoadingByScroll={enableLoadingByScroll}
    >
      {(item) => <SponsorCard data={item} />}
    </ContentList>
  );
}
